/* eslint-disable camelcase */
import { DATE_FORMAT_PLACEHOLDER } from '~constants/dates';

const actionFields = {
  kml: 'Archivo KML',
  dynamic_center_latitude: 'Latitud del centro',
  dynamic_center_longitude: 'Longitud del centro',
  dynamic_map_zoom: 'Nivel de zoom',
  kml_simplified: 'Archivo KML',
  static_center_latitude: 'Latitud del centro',
  static_center_longitude: 'Longitud del centro',
  static_map_zoom: 'Nivel de zoom',
  name: 'Nombre (*)',
  code: 'Código (*)',
  createdAt: 'Creación',
  updatedAt: 'Última modificación',
  totalInvestmentFormatted: 'Inversión total',
  description: 'Descripción',
  investment: 'Inversión',
  countries: 'Países (*)',
  territories: 'Territorios (*)',
  subthemes: 'Subtemas (*)',
  types: 'Tipos',
  scopes: 'Ámbitos (*)',
  stage: 'Etapa (*)',
  term: 'Plazo',
  source: 'Fuente (*)',
  responsibles: 'Responsables',
  segments: 'Tramos',
  funding: 'Financiamiento',
  funding_type: 'Tipo de financiamiento',
  funder: 'Financiador',
  studies_funder: 'Financiador de los estudios',
  estimated_investment: 'Inversión estimada en USD (*)',
  investment_unidentified: 'Inversión sin identificar',
  is_bid: 'BID',
  is_caf: 'CAF',
  is_fonplata: 'FONPLATA',
  accompaniment: 'Acompañamiento',
  is_portfolio: 'Portafolio',
  is_anchor: 'Ancla',
  total_investment_min: 'Inversión mínima',
  total_investment_max: 'Inversión máxima'
};

const catalogFields = {
  id: 'ID',
  name: 'Nombre (ES)',
  nameEs: 'Nombre (ES)',
  nameEn: 'Nombre (EN)',
  namePt: 'Nombre (PT)'
};

export const spanishResources = {
  resources: {
    actions: { name: 'Acciones', fields: actionFields },
    'draft-actions': { name: 'Acciones (borrador)', fields: actionFields },
    themes: { name: 'Temas', fields: catalogFields },
    subthemes: { name: 'Subtemas', fields: { ...catalogFields, theme: 'Tema' } },
    'chart-categories': { name: 'Categorías de gráficos', fields: catalogFields },
    'subtheme-categories': {
      name: 'Subtemas por categoría',
      fields: { id: 'ID', source: 'Fuente', subtheme: 'Subtema', category: 'Categoría de gráfico' }
    },
    types: { name: 'Tipos', fields: catalogFields },
    scopes: { name: 'Ámbitos', fields: catalogFields },
    terms: { name: 'Plazos', fields: catalogFields },
    sources: {
      name: 'Fuentes',
      fields: {
        ...catalogFields,
        shortName: 'Nombre corto (ES)',
        shortNameEs: 'Nombre corto (ES)',
        shortNameEn: 'Nombre corto (EN)',
        shortNamePt: 'Nombre corto (PT)',
        order: 'Orden'
      }
    },
    priorizaciones: {
      name: 'Priorizaciones',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)'
      }
    },
    etapas: {
      name: 'Etapas',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)'
      }
    },
    'financiadores-estudios': {
      name: 'Financiadores de Estudios',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)'
      }
    },
    paises: {
      name: 'Países',
      fields: {
        id: 'ID',
        name: 'Nombre',
        code: 'Código ISO (2 letras)',
        flag: 'Bandera'
      }
    },
    metrics: {
      name: 'Métricas',
      fields: {
        id: 'ID',
        name: 'Nombre',
        slug: 'Identificador',
        unit: 'Unidad',
        category: 'Categoría'
      }
    },
    'metric-values': {
      name: 'Valores de Métricas',
      fields: {
        id: 'ID',
        metric: 'Métrica',
        pais: 'País',
        etapa: 'Etapa',
        subtema: 'Subtema',
        value: 'Valor',
        detalle: 'Detalle'
      }
    },
    disclaimers: {
      name: 'Disclaimers',
      fields: {
        id: 'ID',
        titleEs: 'Título (ES)',
        titleEn: 'Título (EN)',
        titlePt: 'Título (PT)',
        disclaimerEs: 'Disclaimer (ES)',
        disclaimerEn: 'Disclaimer (EN)',
        disclaimerPt: 'Disclaimer (PT)',
        order: 'Orden'
      }
    },
    studies: {
      name: 'Estudios (menú)',
      fields: {
        id: 'ID',
        titleEs: 'Título (ES)',
        titleEn: 'Título (EN)',
        titlePt: 'Título (PT)',
        urlEs: 'Enlace (ES), por ejemplo el PDF del estudio',
        urlEn: 'Enlace (EN); vacío usa el de ES',
        urlPt: 'Enlace (PT); vacío usa el de ES',
        order: 'Orden'
      }
    }
  },
  fieldGroups: {
    projectInformation: 'Datos básicos de la acción',
    dynamicMap: 'Mapa dinámico',
    staticMap: 'Mapa estático',
    projectSections: 'Tramos',
    projectFunding: 'Financiamiento',
    galleryItems: 'Items de galeria',
    scope: 'Objetivo y descripción',
    ilat: 'ILAT',
    general: 'Clasificación',
    projectStatus: 'Estado de la acción',
    routeInformation: 'Datos del territorio',
    routeMap: 'Mapa del territorio',
    routeEs: 'Español',
    routeEn: 'English',
    routePt: 'Português',
    priorizacion: 'Información de Priorización',
    priorizacionEs: 'Español',
    priorizacionEn: 'English',
    priorizacionPt: 'Português',
    etapa: 'Información de Etapa',
    etapaEs: 'Español',
    etapaEn: 'English',
    etapaPt: 'Português',
    catalogEs: 'Español',
    catalogEn: 'English',
    catalogPt: 'Português',
    fuenteTab: 'Pestaña en el Home (el nombre corto vacío usa el nombre)',
    subtema: 'Tema al que pertenece',
    subtemaCategoria: 'En los gráficos del Home de la fuente, el subtema se cuenta en la categoría',
    financiadorEstudios: 'Información de Financiador de Estudios',
    financiadorEstudiosEs: 'Español',
    financiadorEstudiosEn: 'English',
    financiadorEstudiosPt: 'Português',
    pais: 'Información de País',
    metric: 'Información de Métrica',
    metricValue: 'Información de Valor de Métrica',
    disclaimer: 'Información del Disclaimer',
    disclaimerEs: 'Español',
    disclaimerEn: 'English',
    disclaimerPt: 'Português',
    estudioEs: 'Español',
    estudioEn: 'English',
    estudioPt: 'Português'
  },
  auth: {
    credentialsError: 'Credenciales erroneas'
  },
  provider: {
    invalidAction: 'Acción invalida'
  },
  common: {
    actions: 'Acciones',
    published: 'Publicado',
    unpublished: 'No Publicado'
  },
  buttons: {
    publish: 'Publicar',
    unpublish: 'Marcar como no publicado',
    promote: 'Convertir en Acción',
    edit: 'Editar',
    recomputeMetrics: 'Recalcular todas las métricas',
    reprocessLayer: 'Reprocesar'
  },
  metrics: {
    recomputeStarted: 'Recálculo de métricas iniciado',
    recomputeError: 'No se pudo iniciar el recálculo de métricas',
    recomputeInProgress: 'Recálculo de métricas en curso…'
  },
  layers: {
    reprocessStarted: 'Reingesta de la capa iniciada',
    reprocessError: 'No se pudo iniciar la reingesta'
  },
  errors: {
    maxLength: 'Máximo %{count} caracteres',
    required: 'Campo requerido',
    email: 'Ingrese un email válido',
    date: `Ingrese una fecha válida en el formato ${DATE_FORMAT_PLACEHOLDER}`,
    duplicateCountries: 'Hay países repetidos'
  },
  ra: {
    auth: {
      user_menu: 'Perfil', // eslint-disable-line camelcase
      logout: 'Cerrar sesión'
    }
  },
  appBar: {
    menu: 'Menú'
  },
  login: {
    Username: 'Nombre de usuario',
    Password: 'Contraseña',
    Continue: 'Continuar'
  },
  userType: {
    administrator: 'Admin',
    editor: 'Editor'
  }
};
